import { render, staticRenderFns } from "./ClosePeriod.vue?vue&type=template&id=b4564a32&"
import script from "./ClosePeriod.vue?vue&type=script&lang=ts&"
export * from "./ClosePeriod.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/agent/workspace/SPP/deployment/frontend-erp-spp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b4564a32')) {
      api.createRecord('b4564a32', component.options)
    } else {
      api.reload('b4564a32', component.options)
    }
    module.hot.accept("./ClosePeriod.vue?vue&type=template&id=b4564a32&", function () {
      api.rerender('b4564a32', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cash-management/open-close-period/ClosePeriod.vue"
export default component.exports